import React from 'react'

import { RemoteControlRow } from '../remote-control-row'
import Text from '../../ui/Text'
import { SDimmerButton } from '../remote-ocpp-dimmer-control'
import { ChargePoint } from '../loadChargePoint'
import useText from '../../common/hooks/useText'

export type RemoteCapiDimmerControlProps = {
    chargePoint: ChargePoint
    isReadOnly: boolean
    applyChargePoint: (chargePoint: ChargePoint) => Promise<void>
}

enum CapiDimmerState {
    OFF = 0,
    LOW = 8,
    MEDIUM = 64,
    HIGH = 255,
}

export function RemoteCapiDimmerControl({
    chargePoint,
    isReadOnly,
    applyChargePoint,
}: RemoteCapiDimmerControlProps): React.ReactElement {
    const text = useText()
    const getDimmerValueText = () => {
        if (chargePoint.dimmer === CapiDimmerState.OFF) {
            return text('lblOff')
        } else if (chargePoint.dimmer === CapiDimmerState.LOW) {
            return text('lblDimmerValueLow')
        } else if (chargePoint.dimmer === CapiDimmerState.MEDIUM) {
            return text('lblDimmerValueMed')
        } else if (chargePoint.dimmer === CapiDimmerState.HIGH) {
            return text('lblDimmerValueHigh')
        } else {
            return text('btnDimmerValueCustom')
        }
    }

    const changeDimmer = async () => {
        let newDimmerValue
        if (chargePoint.dimmer === CapiDimmerState.OFF) {
            newDimmerValue = CapiDimmerState.LOW
        } else if (chargePoint.dimmer <= CapiDimmerState.LOW) {
            newDimmerValue = CapiDimmerState.MEDIUM
        } else if (chargePoint.dimmer <= CapiDimmerState.MEDIUM) {
            newDimmerValue = CapiDimmerState.HIGH
        } else {
            newDimmerValue = CapiDimmerState.OFF
        }

        await applyChargePoint({ dimmer: newDimmerValue })
    }

    return (
        <RemoteControlRow
            button={
                <SDimmerButton
                    isOn={chargePoint.dimmer !== CapiDimmerState.OFF}
                    onClick={changeDimmer}
                    disabled={isReadOnly}
                    data-testid={`dimmer-${chargePoint.id}`}
                >
                    {getDimmerValueText()}
                </SDimmerButton>
            }
            title={
                <div data-testid={`dimmerText-${chargePoint.id}`}>
                    <Text code="lblLEDBrightness" />
                </div>
            }
        />
    )
}
